import React, {Component} from 'react'
import PropTypes from "prop-types";
import {CannabisPDFDenied} from "./CannabisPDFDenied";
import SvGraphics from "../../../../assets/SvGraphics";
import {VisitSummaryPDF} from "../../PatientOnboardTabs/VisitSummaryPDF";
import doctorApi from "../../../../services/ApiServices/doctorApi";
class RequestDeclarationTab extends Component {

    constructor(props) {
        super(props);
        this.state = {
            checkboxes: this.props.checkboxes,
            entry: this.props.entry,
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.entry !== prevProps.entry) {
            this.setState({
                entry: this.props.entry
            })
        }
        if (this.props.checkboxes !== prevProps.checkboxes) {
            this.setState({
                checkboxes: this.props.checkboxes
            })
        }
    }

    componentDidMount() {
    }
    render() {
        let {t} = this.props

        let {checkboxes, entry} = this.state

        return (
            <div className={'patientForm-box-container'}>
                <div className={'patientsFormBoxes-title-text'}>
                    <label
                        className={'patientsFormBoxes-title-text-label'}> {t('patient_self_boarding.declarations')}</label>
                </div>
                <div className={'patientsFormBoxes'}>

                    <div className={'patientsFormRow-declarations'}>
                        <label className={'infoLabel-declerations'}>{t('patient_boarding.use_cannabis_risk')}</label>
                    </div>
                    <div className={'patientsFormRow-declarations'}>
                        <SvGraphics width={"12px"} height={"20px"} svgname={'dot'}/>
                        <label className={'infoLabel-declerations'}>{t('patient_boarding.Declaration1')}</label>
                    </div>

                    <div className={'patientsFormRow-declarations'}>
                        <SvGraphics width={"12px"} height={"20px"} svgname={'dot'}/>
                        <label className={'infoLabel-declerations'}>{t('patient_boarding.Declaration2')}</label>
                    </div>

                    <div className={'patientsFormRow-declarations'}>
                        <SvGraphics width={"12px"} height={"20px"} svgname={'dot'}/>
                        <label className={'infoLabel-declerations'}>{t('patient_boarding.Declaration3')}</label>
                    </div>
                    {/*<div className={'patientsFormRow-declarations'}>
                        <SvGraphics width={"12px"} height={"20px"} svgname={'dot'}/>
                        <label className={'infoLabel-declerations'}>{t('patient_boarding.Declaration4')}</label>
                    </div>*/}
                    <div className={'patientsFormRow-declarations'}>
                        <SvGraphics width={"12px"} height={"20px"} svgname={'dot'}/>
                        <label className={'infoLabel-declerations'}>{t('patient_boarding.Declaration5')}</label>
                    </div>
                    <div className={'patientsFormRow-declarations'}>
                        <SvGraphics width={"12px"} height={"20px"} svgname={'dot'}/>
                        <label className={'infoLabel-declerations'}>{t('patient_boarding.Declaration6')}</label>
                    </div>
                    <div className={'patientsFormRow-declarations'}>
                        <SvGraphics width={"12px"} height={"20px"} svgname={'dot'}/>
                        <label className={'infoLabel-declerations'}>{t('patient_boarding.Declaration7')}</label>
                    </div>
                    <div className={'patientsFormRow-declarations'}>
                        <SvGraphics width={"12px"} height={"20px"} svgname={'dot'}/>
                        <label className={'infoLabel-declerations'}>{t('patient_boarding.Declaration8')}</label>
                    </div>
                    <div className={'patientsFormRow-declarations'}>
                        <SvGraphics width={"12px"} height={"20px"} svgname={'dot'}/>
                        <label className={'infoLabel-declerations'}>{t('patient_boarding.Declaration9')}</label>
                    </div>
                    <div className={'patientsFormRow-declarations'}>
                        <SvGraphics width={"12px"} height={"20px"} svgname={'dot'}/>
                        <label className={'infoLabel-declerations'}>{t('patient_boarding.Declaration10')}</label>
                    </div>
                    <div className={'patientsFormRow-declarations'}>
                        <SvGraphics width={"12px"} height={"20px"} svgname={'dot'}/>
                        <label className={'infoLabel-declerations'}>{t('patient_boarding.Declaration12')}</label>
                    </div>
                    <div className={'blankSpace'}/>

                    <div className={'patientsFormRow-declarations'}>
                        <label className={'infoLabel-declerations'}>{t('patient_boarding.Declaration11')}</label>
                    </div>

                    <div className={'blankSpace'}/>

                    <div className={'patientsFormRow-declarations'}>
                        <label className={'infoLabel-declerations'}>{t('patient_boarding.Declaration13')}</label>
                    </div>
                    <div className={'patientsFormRow-declarations'}>
                        <SvGraphics width={"12px"} height={"20px"} svgname={'dot'}/>
                        <label className={'infoLabel-declerations'}>{t('patient_boarding.Declaration14')}</label>
                    </div>
                    <div className={'patientsFormRow-declarations'}>
                        <SvGraphics width={"12px"} height={"20px"} svgname={'dot'}/>
                        <label className={'infoLabel-declerations'}>{t('patient_boarding.Declaration15')}</label>
                    </div>
                    <div className={'patientsFormRow-declarations'}>
                        <SvGraphics width={"12px"} height={"20px"} svgname={'dot'}/>
                        <label className={'infoLabel-declerations'}>{t('patient_boarding.Declaration16')}</label>
                    </div>
                    <div className={'patientsFormRow-declarations'}>
                        <SvGraphics width={"12px"} height={"20px"} svgname={'dot'}/>
                        <label className={'infoLabel-declerations'}>{t('patient_boarding.Declaration17')}</label>
                    </div>
                    <div className={'patientsFormRow-declarations'}>
                        <SvGraphics width={"12px"} height={"20px"} svgname={'dot'}/>
                        <label className={'infoLabel-declerations'}>{t('patient_boarding.Declaration18')}</label>
                    </div>
                    <div className={'patientsFormRow-declarations'}>
                        <SvGraphics width={"12px"} height={"20px"} svgname={'dot'}/>
                        <label className={'infoLabel-declerations'}>{t('patient_boarding.Declaration19')}</label>
                    </div>
                    <div className={'patientsFormRow-declarations'}>
                        <SvGraphics width={"12px"} height={"20px"} svgname={'dot'}/>
                        <label className={'infoLabel-declerations'}>{t('patient_boarding.Declaration20')}</label>
                    </div>
                    <div className={'patientsFormRow-declarations'}>
                        <SvGraphics width={"12px"} height={"20px"} svgname={'dot'}/>
                        <label className={'infoLabel-declerations'}>{t('patient_boarding.Declaration21')}</label>
                    </div>
                    <div className={'patientsFormRow-declarations'}>
                        <SvGraphics width={"12px"} height={"20px"} svgname={'dot'}/>
                        <label className={'infoLabel-declerations'}>{t('patient_boarding.Declaration22')}</label>
                    </div>
                    <div className={'patientsFormRow-declarations'}>
                        <SvGraphics width={"12px"} height={"20px"} svgname={'dot'}/>
                        <label className={'infoLabel-declerations'}>{t('patient_boarding.Declaration23')}</label>
                    </div>
                    <div className={'patientsFormRow-declarations'}>
                        <SvGraphics width={"12px"} height={"20px"} svgname={'dot'}/>
                        <label className={'infoLabel-declerations'}>{t('patient_boarding.Declaration24')}</label>
                    </div>
                    <div className={'patientsFormRow-declarations'}>
                        <SvGraphics width={"12px"} height={"20px"} svgname={'dot'}/>
                        <label className={'infoLabel-declerations'}>{t('patient_boarding.Declaration25')}</label>
                    </div>
                    <div className={'patientsFormRow-declarations'}>
                        <SvGraphics width={"12px"} height={"20px"} svgname={'dot'}/>
                        <label className={'infoLabel-declerations'}>{t('patient_boarding.Declaration26')}</label>
                    </div>
                    <div className={'patientsFormRow-declarations'}>
                        <SvGraphics width={"12px"} height={"20px"} svgname={'dot'}/>
                        <label className={'infoLabel-declerations'}>{t('patient_boarding.Declaration27')}</label>
                    </div>
                    <div className={'blankSpace'}/>

                    <div className={'patientsFormRow-declarations'}>
                        <label className={'infoLabel-declerations'}>{t('patient_boarding.instruction_info')}</label>
                    </div>

                    <div className={'patientsFormRow-declarations'}>
                        <SvGraphics width={"12px"} height={"20px"} svgname={'dot'}/>
                        <label className={'infoLabel-declerations'}>{t('patient_boarding.Instruction1')}</label>
                    </div>
                    <div className={'patientsFormRow-declarations'}>
                        <SvGraphics width={"12px"} height={"20px"} svgname={'dot'}/>
                        <label className={'infoLabel-declerations'}>{t('patient_boarding.Instruction2')}</label>
                    </div>
                    <div className={'patientsFormRow-declarations'}>
                        <SvGraphics width={"12px"} height={"20px"} svgname={'dot'}/>
                        <label className={'infoLabel-declerations'}>{t('patient_boarding.Instruction3')}</label>
                    </div>
                    <div className={'patientsFormRow-declarations'}>
                        <SvGraphics width={"12px"} height={"20px"} svgname={'dot'}/>
                        <label className={'infoLabel-declerations'}>{t('patient_boarding.Instruction4')}</label>
                    </div>
                    <div className={'patientsFormRow-declarations'}>
                        <SvGraphics width={"12px"} height={"20px"} svgname={'dot'}/>
                        <label className={'infoLabel-declerations'}>{t('patient_boarding.Instruction5')}</label>
                    </div>
                  {/*  <div className={'patientsFormRow-declarations'}>
                        <SvGraphics width={"12px"} height={"20px"} svgname={'dot'}/>
                        <label className={'infoLabel-declerations'}>{t('patient_boarding.Instruction6')}</label>
                    </div>*/}

                    {/*<div className={'patientsFormRow-declarations'}>*/}
                    {/*    <SvGraphics width={"12px"} height={"20px"} svgname={'dot'}/>*/}
                    {/*    <label className={'infoLabel-declerations'}>{t('patient_boarding.Instruction6')}</label>*/}
                    {/*</div>*/}

                    <div className={'blankSpace'}/>
                    <div className={'patientsFormRow-declarations'}>
                        <label className={'infoLabel-declerations'}>{t('patient_boarding.DeclarationEnd')}</label>
                    </div>
                    <div className={'blankSpace'}/>

                    <div className={'checkbox-label'}>
                        <input type={"checkbox"} className={"checkboxStyle"} name={'DeclarationAccept'} checked={entry.DeclarationAccept}
                               onChange={event => this.props.onClickCheckboxes(event.target.name)}/>
                        <label className={'infoLabel'} style={{color:'#000000'}}>{t('patient_boarding.DeclarationAcceptDoctor')}</label>
                    </div>
                    <div className={'checkbox-label'}>
                        <input type={"checkbox"} className={"checkboxStyle"} name={'AcceptFutureContact'} checked={entry.AcceptFutureContact}
                               onChange={event => this.props.onClickCheckboxes(event.target.name)}/>
                        <label className={'infoLabel'} style={{color:'#000000'}}>{t('patient_boarding.AcceptFutureContactDoctor')}</label>
                    </div>

                </div>
            </div>

        )
    }
}

RequestDeclarationTab.propTypes = {
    onValueChange: PropTypes.func.isRequired,
    onClickCheckboxes: PropTypes.func.isRequired,
    entry: PropTypes.object.isRequired,
    checkboxes: PropTypes.object.isRequired,
    isDisabled: PropTypes.bool
}

export default RequestDeclarationTab;
